/*
 * Popup v3: center-kaart op alle pagina's (de PDP-bottom-sheet is vervallen).
 * Banner-regel: de popup verschijnt nooit tegelijk met of direct na de cookiebanner.
 *   - banner beantwoord  -> 6s adempauze, daarna pas de engagement-triggers armen
 *   - banner genegeerd   -> pas armen bij duidelijk browse-gedrag (scroll >= 60% of 2e pageview)
 *   - geen banner        -> direct armen
 * Triggers daarna: browse-pagina's scroll >= 50% EN minimaal 15s op de pagina, OF
 * exit-intent (zonder tijdsvloer) -- geen kale dwell-timer meer (die onderbrak koud
 * verkeer dat nog aan het lezen was; 441 dismissals vs 40 signups, rapport 6 aug).
 * PDP: vrijwillige cadeauknop; automatisch pas bij scroll >= 40% EN minimaal 15s.
 * Met iets in de winkelwagen verschijnt de popup helemaal niet (koopflow niet onderbreken).
 * Shadow-classifier: elke bezoeker krijgt warm/koud-tagging mee in GA4 + Klaviyo
 * (alleen meten; het aanbod is voor iedereen gelijk tot er beslisdata is).
 */
function whenBannerSettled(cb) {
  var consent = window.hotConsent;
  var done = false;
  var decided = false;

  function cleanup() {
    window.removeEventListener('hot:consent', decide);
    document.removeEventListener('visitorConsentCollected', onSettle);
    window.removeEventListener('scroll', onScroll);
  }

  function go(pauseMs) {
    if (done) return;
    done = true;
    cleanup();
    pauseMs ? setTimeout(cb, pauseMs) : cb();
  }

  function onSettle() { go(6000); }

  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.6) go(0);
  }

  // Pas beslissen als Shopify's privacy-API geladen is: eerder is niet te zien of de melding open staat.
  // Is de API niet te laden (geblokkeerd), dan komt er ook geen melding: gewoon armen.
  function decide() {
    if (done || decided) return;
    if (consent.failed()) return go(0);
    if (!consent.ready()) return;
    decided = true;
    window.removeEventListener('hot:consent', decide);
    if (!consent.bannerOpen()) return go(0);

    // Banner staat nog open. Tel pageviews binnen de sessie: wie op een 2e pagina
    // komt zonder de banner te beantwoorden, is aan het browsen en mag de popup zien.
    var pv = 1;
    try {
      pv = (parseInt(sessionStorage.getItem('hot:popup-pv') || '0', 10) || 0) + 1;
      sessionStorage.setItem('hot:popup-pv', String(pv));
    } catch (e) { /* private mode */ }
    if (pv >= 2) return go(0);

    document.addEventListener('visitorConsentCollected', onSettle, { once: true });
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (!consent) return go(0);
  window.addEventListener('hot:consent', decide);
  decide();
}

class SocialFloating extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.querySelectorAll('[data-social-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!theme.config.mqlSmall) return;

    this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.classList.add(this.classes.activeClass);

    // close promo-popup
    const popup = document.querySelector('promo-popup');
    popup && popup.close();
  }

  close() {
    this.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.classList.remove(this.classes.activeClass);
      this.classList.remove(this.classes.closingClass);
    }, 500);
  }
}
customElements.define('social-floating', SocialFloating);

class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'hot:popup-v2';
    this.subCookieName = 'hot:popup-v2-sub';
    this.isPdp = this.dataset.trigger === 'engagement';

    // In-app browsers (Google-app/GSA, Meta, TikTok, Snap, Pinterest, LinkedIn,
    // Android WebView) leggen eigen balken over de viewportranden zonder dat
    // CSS-units of JS dat kunnen zien; popup-v2.css zet met deze klasse alle
    // sluit- en conversie-routes ruimer van de randen af.
    this.isInApp = /GSA\/|FBAN|FBAV|FB_IAB|Instagram|Snapchat|Pinterest\/|LinkedInApp|musical_ly|BytedanceWebview|; wv\)/.test(navigator.userAgent);
    if (this.isInApp) this.classList.add('is-inapp');
    this.segment = this.classifySegment();
    this.variant = (this.isPdp ? 'v3_pdp' : 'v3_card') + '_' + this.segment;
    this.dataset.variant = this.variant;

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');
    this.card = this.popup ? this.popup.querySelector('.popup') : null;
    this.teaser = this.querySelector('.popup-floating');

    // Open modal only if a VISIBLE (non-hidden, non-empty) form message exists.
    // The Klaviyo form always renders hidden empty message nodes, which would
    // otherwise force the popup open immediately (bypassing delay + consent).
    if (this.querySelector('.form__message:not([hidden]):not(:empty)')) {
      this.open();
    }

    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    // Kortingscode op het succes-scherm: tik = kopieer naar klembord.
    this.querySelectorAll('[data-popup-code-copy]').forEach((btn) => {
      btn.addEventListener('click', function () {
        var el = btn.querySelector('[data-popup-code]');
        var code = el ? (el.textContent || '').trim() : '';
        if (!code) return;
        var mark = function () { btn.classList.add('is-copied'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(mark).catch(mark);
        } else {
          mark();
        }
      });
    });

    if (this.teaser) {
      this.teaser.querySelectorAll('[data-popup-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          if ((window.hotConsent?.analytics() === true || window.hotConsent?.marketing() === true) && typeof window.gtag === 'function') window.gtag('event', 'popup_teaser_open', { popup: this.variant });
        });
      });
    }

    if (this.dataset.testMode === 'true') {
      this.init();
    } else if (this.getCookie(this.subCookieName)) {
      // Al ingeschreven: geen popup en geen teaser meer.
    } else if (this.getCookie(this.cookieName)) {
      // Recent gesloten: geen auto-open, wel het teaser-tabje als tweede kans.
      this.showTeaser();
    } else {
      this.init();
    }
  }

  // Shadow-classifier warm/koud (alleen tagging, stuurt GEEN ander aanbod).
  // Koud = eerste sessie via betaald verkeer (fbclid/gclid, utm paid/Meta-bronnen).
  // Warm = terugkerend (2e+ sessie), uit onze e-mail (_kx / utm_medium=email) of
  // organisch zoekverkeer zonder paid-params. Ambigu (direct, eerste bezoek) telt
  // als koud: een cadeau tonen aan koud kost marge, proof tonen aan warm hooguit
  // scherpte -- de kosten zijn asymmetrisch. First-touch staat in localStorage
  // (Safari ITP wist die na ~7 dagen inactiviteit; een deel "nieuw" is dus
  // eigenlijk terugkerend -- geaccepteerde ruis, zie METRIC-CONTRACT.md).
  classifySegment() {
    var KEY = 'hot:popup-ft';
    var rec = null;
    try { rec = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!rec || typeof rec !== 'object') rec = { seg: null, n: 0 };

    var newSession = false;
    try {
      if (!sessionStorage.getItem('hot:popup-sess')) {
        newSession = true;
        sessionStorage.setItem('hot:popup-sess', '1');
      }
    } catch (e) { /* private mode: elke pageview telt dan als sessie, veilig */ }
    if (newSession) rec.n = (rec.n || 0) + 1;

    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { p = null; }
    var src = p ? (p.get('utm_source') || '').toLowerCase() : '';
    var med = p ? (p.get('utm_medium') || '').toLowerCase() : '';
    var paid = p && (p.has('fbclid') || p.has('gclid') ||
      ['facebook', 'ig', 'instagram', 'meta'].indexOf(src) >= 0 ||
      ['paid', 'cpc', 'ppc', 'paid_social'].indexOf(med) >= 0);
    var email = p && (med === 'email' || p.has('_kx'));
    var organic = !paid && /^https?:\/\/([^/]*\.)?(google|bing|duckduckgo|ecosia|startpage)\./.test(document.referrer || '');

    if (email) rec.seg = 'warm';
    else if (rec.n >= 2) rec.seg = 'warm';
    else if (paid) rec.seg = 'cold';
    else if (!rec.seg) rec.seg = organic ? 'warm' : 'cold';

    try { localStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) {}
    return rec.seg || 'cold';
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  init() {
    if (!this.popup) {
      return;
    }

    if (Shopify && Shopify.designMode) {
      return;
    }

    if ((this.dataset.consentMode || '').toLowerCase() === 'disabled') {
      return;
    }

    // Met iets in de winkelwagen geen popup: de koopbeslissing niet onderbreken.
    // Fail-open: als /cart.js niet antwoordt, gedraagt de popup zich als voorheen.
    var self = this;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count > 0) return;
        whenBannerSettled(function () { self.arm(); });
      })
      .catch(function () {
        whenBannerSettled(function () { self.arm(); });
      });
  }

  // Engagement-triggers: de popup komt pas als de bezoeker echt aan het lezen/scrollen is.
  // Browse: scroll >= 50% EN minimaal 15s op de pagina, OF exit-intent (zonder vloer:
  // een vertrekkende bezoeker onderbreek je niet meer, tonen kost daar niks).
  // De 15s-vloer vangt de mobiele flick-scroller die in 5s naar beneden veegt zonder
  // te lezen (Fable-review 11 aug; 30s sloot ook echte lezers uit, gem. engagement
  // paid social is 34s). PDP: scroll >= 40% EN minimaal 15s, of desktop exit-intent.
  arm() {
    var self = this;
    var fired = false;
    var armedAt = Date.now();
    var scrollThreshold = this.isPdp ? 0.4 : 0.5;
    var minElapsedMs = 15000;
    var pendingTimer = null;
    var floorLogged = false;

    function fire(skipFloor) {
      if (fired) return;
      if (self.getCookie(self.cookieName) || self.getCookie(self.subCookieName) || self.popup.classList.contains(self.classes.activeClass)) {
        fired = true;
        cleanup();
        return;
      }
      var wait = minElapsedMs - (Date.now() - armedAt);
      if (wait > 0 && !skipFloor) {
        // Engagement is er, maar de vloer nog niet: vuren zodra die verstreken is.
        // Shadow-event zodat de 15s-keuze falsifieerbaar is in de wekelijkse readout.
        if (!floorLogged && (window.hotConsent?.analytics() === true || window.hotConsent?.marketing() === true) && typeof window.gtag === 'function' && !(Shopify && Shopify.designMode)) {
          floorLogged = true;
          window.gtag('event', 'popup_suppressed_by_floor', {
            popup: self.variant,
            segment: self.segment,
            dwell_s: Math.round((Date.now() - armedAt) / 1000)
          });
        }
        if (!pendingTimer) pendingTimer = setTimeout(fire, wait);
        return;
      }
      fired = true;
      cleanup();
      // A cart may have been filled since init(): do not interrupt the purchase.
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (!cart || cart.item_count > 0) return;
          if (self.getCookie(self.cookieName) || self.getCookie(self.subCookieName) || self.popup.classList.contains(self.classes.activeClass)) return;
          if (document.querySelector('cart-drawer details[open], product-modal[open], header-drawer details[open]')) return;
          self.open();
        })
        .catch(function () { /* Keep the optional teaser available. */ });
    }

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= scrollThreshold) fire();
    }

    function onExitIntent(e) {
      if (window.innerWidth >= 750 && e.clientY <= 0 && !e.relatedTarget) fire(true);
    }

    function cleanup() {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExitIntent);
      clearTimeout(pendingTimer);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExitIntent);
    // Request the gift without interrupting the product gallery.
    if (this.isPdp) this.showTeaser();
    // Al voorbij de drempel gescrold (bv. tijdens de adempauze)? Dan is de
    // engagement er al -- direct vuren, niet wachten op een volgend scroll-event.
    onScroll();
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.hideTeaser();
    document.body.classList.remove(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      setScrollbarWidth();
      this.lockBodyScroll();
    }

    // close social-floating
    const social = document.querySelector('social-floating');
    social && social.close();

    if (!(Shopify && Shopify.designMode) && (window.hotConsent?.analytics() === true || window.hotConsent?.marketing() === true) && typeof window.gtag === 'function') {
      window.gtag('event', 'popup_view', { popup: this.variant, segment: this.segment, in_app: this.isInApp });
    }
  }

  close() {
    // Dismiss-meting: alleen een echte sluiting telt (popup stond open, bezoeker
    // niet ingeschreven) -- close() wordt ook defensief aangeroepen op een dichte popup.
    if (
      this.popup.classList.contains(this.classes.activeClass) &&
      !this.getCookie(this.subCookieName) &&
      !(Shopify && Shopify.designMode) &&
      (window.hotConsent?.analytics() === true || window.hotConsent?.marketing() === true) && typeof window.gtag === 'function'
    ) {
      window.gtag('event', 'popup_close', { popup: this.variant, segment: this.segment, in_app: this.isInApp });
    }

    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        this.unlockBodyScroll();
      }
    }, 500);

    // Remove cookies in case they were set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      this.removeCookie(this.subCookieName);
      return;
    }

    if (this.getCookie(this.subCookieName)) return;

    this.setCookie(this.cookieName, this.dataset.expiry);
    this.showTeaser();
  }

  // Aangeroepen door klaviyo-subscribe.js na een geslaagde inschrijving.
  onSignupSuccess() {
    if (this.dataset.testMode !== 'true') {
      this.setCookie(this.subCookieName, 365);
    }
    this.hideTeaser();
  }

  // iOS Safari negeert `overflow:hidden` op body voor touch-scroll -- de achtergrond
  // blijft anders zichtbaar meebewegen achter de popup. position:fixed (CSS, mobiel-only)
  // is de enige betrouwbare lock; scrollt bij close terug naar exact dezelfde plek.
  lockBodyScroll() {
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-this._scrollY) + 'px';
    document.body.classList.add(this.classes.bodyClass);
  }

  unlockBodyScroll() {
    document.body.classList.remove(this.classes.bodyClass);
    document.body.style.top = '';
    window.scrollTo(0, this._scrollY || 0);
  }

  showTeaser() {
    this.teaser && this.teaser.classList.add('is-visible');
  }

  hideTeaser() {
    this.teaser && this.teaser.classList.remove('is-visible');
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
